<template>
  <div>
    <el-dialog :close-on-click-modal="false"
        :title="title"
        :visible.sync="addsign"
        :before-close="addProClose"
        width="105.5rem"
        center
        top="2vh"
      >
        <el-divider></el-divider>
        <div class="">
            <el-form ref="formName" :rules="rules" :model="form" label-width="130px">
              <el-form-item label="活动名称：" prop="title">
                <el-input v-model="form.title" placeholder="请输入内容"></el-input>
              </el-form-item>
              <div class="flex">
                <el-form-item label="报名截止时间：" prop="starttime">
                  <el-date-picker
                    v-model="form.starttime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="活动时间：" prop="endtime">
                  <el-date-picker
                    v-model="form.endtime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
              </div>
              <el-form-item label="活动地址：" prop="address">
                <div  class="flex_wrap">
                  <el-select
                  v-model="form.province"
                  placeholder="请选择省"
                  @change="provinceChange($event)"
                >
                  <el-option
                      v-for="item in cityProvince"
                      :key="item.provinceCode"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    ></el-option>
                </el-select>
                <span class="span_mar">省</span>
                <el-select
                  v-model="form.city"
                  placeholder="请选择市/区"
                  @change="cityChange($event)"
                >
                <el-option
                    v-for="item in cityDistrict"
                    :key="item.cityCode"
                    :label="item.cityName"
                    :value="item.cityCode"
                  ></el-option>
                </el-select>
                <span class="span_mar">市</span>
                <el-select v-model="form.county" placeholder="请选择县/乡">
                  <el-option
                    v-for="item in cityCounty"
                    :key="item.countyCode"
                    :label="item.countyName"
                    :value="item.countyCode"
                  ></el-option>
                </el-select>
                <span class="span_mar">区</span>
                </div>
                <div class="mar2">
                  <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="活动费用：" prop="activity_cost">
                <div class="windth240">
                  <el-input v-model="form.activity_cost" placeholder="请输入费用"></el-input>
                  <span class="span_mar">元</span>
                </div>
              </el-form-item>
              <div class="flex_one">
                <el-form-item label="总购买限制：">
                  <div  class="flexs">
                    <el-radio v-model="form.buy_limit" label="0">无限制</el-radio>
                    <el-radio v-model="form.buy_limit" label="1">限制</el-radio>
                    <el-input placeholder="请输入内容"  type="number" v-model="buy_limit"></el-input>
                    <span class="span_mar">人</span>
                  </div>
                </el-form-item>
                <el-form-item label="每个ID购买限制：">
                    <div class="flexs">
                      <el-radio v-model="form.single_limit" label="0">无限制</el-radio>
                      <el-radio v-model="form.single_limit" label="1">限制</el-radio>
                      <el-input placeholder="请输入内容"  type="number" v-model="single_limit"></el-input>
                      <span class="span_mar">人</span>
                    </div>
                </el-form-item>
              </div>
              <el-form-item label="是否可退：">
                  <div class="flexs Refundable">
                    <el-radio v-model="form.returnflag" label="1">是</el-radio>
                    <span class="span_mar">用户需在活动时间前</span>
                    <div class="direcoulm">
                      <el-input placeholder="999" v-model="form.advance"></el-input>
                      <span>注：默认999为随时可退</span>
                    </div>
                    <span class="span_mar">天</span>
                    <el-time-select
                      v-model="form.hour"
                      :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '23:45'
                      }"
                      placeholder="选择时间">
                    </el-time-select>
                    <span  class="span_mar">前退购</span>
                    <el-radio v-model="form.returnflag" label="2">否</el-radio>
                  </div>
              </el-form-item>
              <div class="textarea_flex">
                <el-form-item label="活动详情：" prop="detail">
                  <quill-editor 
                      v-model="form.detail" 
                      ref="myQuillEditor" 
                    >
                  </quill-editor>
                  <!-- <el-input type="textarea"  v-model="form.detail" placeholder="例：组织单位/活动日期/报名日期/参加要求"></el-input> -->
                </el-form-item>
              </div>
              <div class="textarea_flex">
                <el-form-item label="活动行程：">
                  <quill-editor 
                      v-model="form.activity_trip
                      " 
                      ref="myQuillEditor" 
                    >
                  </quill-editor>
                  <!-- <el-input type="textarea"  v-model="form.activity_trip" placeholder="例：行程名称/活动时常/活动说明（每个活动行程使用“；”隔开）"></el-input> -->
                </el-form-item>
              </div>
              <el-form-item label="宣传图：">
                  <div class="flexs_upload">
                    <cutImageDialog :imgs="form.img" @resurl="resurl"  v-if="flag" />
                    <span class="upload_span">注：请上传1M一下的图片(此图片用于平台宣传，请认真对待)，支持png、jpg、jpeg
      尺寸（1280*1280）</span>
                  </div>  
              </el-form-item>
            </el-form>
            <div class="buttom_div">
                <div>清空</div>
                <div @click="btns('formName')">保存并制作报名表</div>
            </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import cityOptions from "@/assets/city.json";
import {Message} from 'element-ui'
import cutImageDialog from '@/assets/place.vue'
export default {
  props:['title'],
  data(){
    return{
      addsign:false,
      buy_limit:'',
      single_limit:'',
      form:{
        scenicid:window.sessionStorage.getItem('ScenicId'),
        actId:'',
        title:'',
        starttime:'',
        endtime:'',
        address:'',
        detail:'\t\t\t\t\t\t<p>【组织单位】：</p>\r\n\t\t\t\t\t\t\t<p>【活动日期】：</p>\r\n\t\t\t\t\t\t\t<p>【参加办法】：</p>\r\n\t\t\t\t\t\t\t',
        activity_trip:'\t\t\t\t\t\t<p>【雪具大厅签到】：</p>\r\n\t\t\t\t\t\t\t<p>【自由活动】：</p>\r\n\t\t\t\t\t\t\t<p>【晚餐】：</p>\r\n\t\t\t\t\t\t\t<p>【开营仪式】：</p>\r\n\t\t\t\t\t\t\t<p>【滑雪理论文化教学】：</p>\r\n\t\t\t\t\t\t\t<p>【午餐】：</p>\r\n\t\t\t\t\t\t\t',
        activity_cost:'',
        buy_limit:'1',
        single_limit:'1',
        returnflag:'1',
        advance:'',
        province:'',
        city:'',
        county:'',
        img:'',
        hour:''
      },
      cityProvince:'',
      cityDistrict:[],
      cityCounty:[],
      radio:'1',
      rules:{
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        starttime :[ { required: true, message: '请选择日期', trigger: 'change' }],
        endtime:[ { required: true, message: '请选择日期', trigger: 'change' }],
        address:[{ required: true, message: '请输入活动地址', trigger: 'blur' }],
        detail:[{ required: true, message: '请输入活动详情', trigger: 'blur' }],
        activity_cost:[{ required: true, message: '请输入活动费用', trigger: 'blur' }]
      },
      flag : false
    }
  },
  created(){
    this.cityProvince = cityOptions;
  },
  components: { cutImageDialog },
  methods:{
      resurl(row){
        this.form.img = row
      },
      btns(formName){
        if(this.form.buy_limit=='1'){
          this.form.buy_limit = this.buy_limit
        }
        if(this.form.single_limit=='1'){
          this.form.single_limit = this.single_limit
        }
        if(this.form.returnflag=='1'){
          this.form.advance = ''
          this.form.hour = ''
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/activityAdd",
            this.form
          ).then((res) => {
            if(res.data.code=='666'){
                Message.success('添加成功')
                this.addsign = false
                this.$emit('close',res.data)
                this.form={
                  scenicid:window.sessionStorage.getItem('ScenicId'),
                  actId:'',
                  title:'',
                  starttime:'',
                  endtime:'',
                  address:'',
                  detail:'',
                  activity_trip:'',
                  activity_cost:'',
                  buy_limit:'0',
                  single_limit:'0',
                  returnflag:'1',
                  advance:'',
                  province:'',
                  city:'',
                  county:'',
                  img:'',
                  hour:''
                }
            }
          })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
       
      },
      handleAvatarSuccess(res, file) {
        this.form.img = res.result
      },
       // 选中省
     provinceChange(e) {
      this.cityProvince.forEach((item, index) => {
        if (e == item.provinceCode) {
          this.form.city = ''
          this.form.county = ''
          this.cityDistrict = item.cities;
        }
      });
    },
    // 选中市
    cityChange(e) {
      this.cityDistrict.forEach((item, index) => {
        if (e == item.cityCode) {
          this.form.county = ''
          this.cityCounty = item.counties;
        }
      });
    },
    // 关闭
    addProClose(){
      this.addsign = false
      this.$emit('close')
    },
    // 打开
    pxFn(row){
      this.addsign = true
      console.log()
      if(row==undefined){
        this.flag = true
        this.form.img = ''
      }
      if(row){
        let data = {
        id : row.id
      }
      this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/editActivity",
          data
        ).then((res) => {
          if(res.data.code=='666'){
            this.form = {
              scenicid:window.sessionStorage.getItem('ScenicId'),
              actId:res.data.info.id,
              title:res.data.info.title,
              starttime:res.data.info.starttime,
              endtime:res.data.info.endtime,
              address:res.data.info.address,
              detail:res.data.info.detail,
              activity_trip:res.data.info.activity_trip,
              activity_cost:res.data.info.activity_cost,
              buy_limit:res.data.info.buy_limit + '',
              single_limit:res.data.info.single_limit + '',
              returnflag:res.data.info.returnflag + '',
              advance:res.data.info.advance,
              province:res.data.info.province,
              city:res.data.info.city,
              county:res.data.info.county,
              img:res.data.info.img,
              hour:res.data.info.hour
            }
            this.flag = true
            if(this.form.buy_limit!='0'){
              this.buy_limit  = this.form.buy_limit
              this.form.buy_limit = '1'
            }
            if(this.form.single_limit!='0'){
              this.single_limit  = this.form.single_limit
              this.form.single_limit = '1'
            }
            if(this.form.returnflag!='1'){
              this.form.advance = ''
            }
            this.cityProvince.map((item, index) => {
              if (item.provinceCode == res.data.info.province) {
                this.cityDistrict = item.cities;
              }
            });
            // 市赋值后获取县下拉框对应的值
            this.cityDistrict.map((item, index) => {
              if (item.cityCode == res.data.info.city) {
                this.cityCounty = item.counties;
              }
            })
          }
      })
      }
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
  }
}
</script>
<style lang="less" scoped>
.flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-date-editor{
    width: 35rem;
  }
}
.flexs{
  display: flex;
  align-items: center;
}
.textarea_flex{
  margin-top: 3.5rem;
  .el-textarea{
    height:15rem;
    width: 86.9rem;
    ::v-deep .el-textarea__inner{
        width: 86.9rem;
        height: 15rem;
        resize: none;
    }
  }
}
.direcoulm{
  position: relative;
  span{
    position: absolute;
    color: #FF4D4F;
    width: 100rem;
    bottom: -3.7rem;
    left: 0;
    font-size: 1.4rem;
  }
}
.Refundable{
  .el-input{
    width: 8rem;
  }
  .el-date-editor{
    width: 20rem;
  }
}
.flex_one{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-input{
    width: 17rem;
  }
  ::v-deep .el-form-item__label{
    width: 13rem !important;
  }
  ::v-deep .el-radio {
    margin-right: 1rem !important;
  }
}
.flex_wrap{
  display: flex;
}
.span_mar{
  margin: 0 1rem;
}
.mar2{
  margin-top: 2rem;
}
.windth240{
  .el-input{
    width: 24rem;
  }
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 13.2rem;
    height: 9.6rem;
    border-radius: 0.4rem;
    line-height: 9.6rem;
    text-align: center;
    border: 1px solid #E5E5EA;
  }
  .avatar {
    width: 13.2rem;
    height: 9.6rem;
    display: block;
  }
  .upload_span{
    color: #FF4D4F;
    font-size: 1.4rem;
    margin-left: 2rem;
    display: block;
    width: 52.4rem;
    line-height: 2rem;
  }
  .flexs_upload{
    display: flex;
  }
  .buttom_div{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    >div{
      cursor: pointer;
      height: 4rem;
      border-radius: 0.4rem;
      color: #fff;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      &:nth-child(1){
        width: 10rem;
        background: #D9D9D9;
      }
      &:nth-child(2){
        width: 13rem;
        background: #246DEB;
        margin-left: 2rem;
      }
    }
  }
  ::v-deep .el-dialog__body{
    padding: 0px 20px 20px;
  }
  ::v-deep .el-divider--horizontal{
    margin: 0 0 20px 0;
  }
</style>